import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { ConnectionService } from '../../service/connection.service';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css',
})
export class ForgotPasswordComponent {
  email = '';
  loading = false;
  sent = false;
  error = '';

  constructor(private connection: ConnectionService, private router: Router) {}

  submit() {
    if (!this.email.trim()) {
      this.error = 'Inserisci la tua email.';
      return;
    }
    this.loading = true;
    this.error = '';
    this.connection.post(
      '@auth/forgot-password',
      { email: this.email.trim() },
      () => {
        this.loading = false;
        this.sent = true;
      },
      () => {
        this.loading = false;
        this.error = 'Errore di rete. Riprova tra qualche minuto.';
      },
    );
  }
}
